import React, { Component } from "react";
import moment from "moment";
import Datetime from "react-datetime";

class DateTime extends Component {
  render() {
    const dateValue = this.props.dateValue ? this.props.dateValue : "";
    const {
      name,
      placeholder,
      id,
      className = this.props.name
    } = this.props;
    return (
      <Datetime
        defaultValue={dateValue}
        inputProps={{
          name: name,
          placeholder: placeholder,
          id: id,
          className: className
        }}
      />
    );
  }
}

export default DateTime;
